<!--用电-->
<template>
  <div class="hpElectricityBody">
    <!--用电-->
    <div class="electricityDetailed">
      <div class="todayElectricity">
        <div class="flexCenter roundDiv">
          <img :src="imgName('/huapu/comparison.png')">
          <span style="color: #e5e312;">{{powerData.day}}</span>
        </div>
        <span>今日用{{value==2?'电':'水'}}量</span>
      </div>
      <!--同比环比-->
      <div class="dayYearOnYear">
        <!--同比-->
        <div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
          <div class="flexCenterColumn"><span class="tbtext">同</span><span class="tbtext">比</span></div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">{{powerData.lasMonth}}</span>
            <span>上月同期用{{value==2?'电':'水'}}量</span>
          </div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">
              <img v-if="tongqi.flag" :src="getDownImg">
              <img v-else :src="getUpImg">
              {{tongqi.num}}
            </span>
            <span>上月同期相比</span>
          </div>
        </div>
        <!--环比-->
        <div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
          <div class="flexCenterColumn"><span class="tbtext">环</span><span class="tbtext">比</span></div>
          <div class="flexCenterColumn"><span style="color: #e5e312;">{{powerData.lasDay}}</span>
            <span>昨日同期用{{value==2?'电':'水'}}量</span>
          </div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">
              <img v-if="tongqi2.flag" :src="getDownImg">
              <img v-else :src="getUpImg">
              {{tongqi2.num}}
            </span>
            <span>昨日同期相比</span>
          </div>
        </div>
      </div>
      <div class="todayElectricity">
        <div class="flexCenter roundDiv">
          <img :src="imgName('/huapu/comparison.png')">
          <span style="color: #e5e312;">{{powerData.month}}</span>
        </div>
        <span>本月用{{value==2?'电':'水'}}量</span>
      </div>
      <!--同比环比-->
      <div class="dayYearOnYear">
        <!--同比-->
        <div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
          <div class="flexCenterColumn"><span class="tbtext">同</span><span class="tbtext">比</span></div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">{{powerData.lasMonth2}}</span>
            <span>上月同期用{{value==2?'电':'水'}}量</span>
          </div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">
              <img v-if="tongqi3.flag" :src="getDownImg">
              <img v-else :src="getUpImg">
              {{tongqi3.num}}
            </span>
            <span>上月同期相比</span>
          </div>
        </div>
        <!--环比-->
        <div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
          <div class="flexCenterColumn"><span class="tbtext">环</span><span class="tbtext">比</span></div>
          <div class="flexCenterColumn"><span style="color: #e5e312;">{{powerData.lasYear}}</span>
            <span>去年同期用{{value==2?'电':'水'}}量</span>
          </div>
          <div class="flexCenterColumn">
            <span style="color: #e5e312;">
              <img v-if="tongqi4.flag" :src="getDownImg">
              <img v-else :src="getUpImg">
              {{tongqi4.num}}
            </span>
            <span>去年同期相比</span>
          </div>
        </div>
      </div>
    </div>
    <!--图形-->
    <p class="areaTitle">
      <el-select v-model="value" placeholder="请选择" size="mini" @change="valueFn" style="width: 80px;">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> {{value==2?'（单位：KWH）':'（单位：m³）'}}
    </p>
    <div class="electricityGraphics">
      <!--能耗-->
      <div class="energyConsumption" :style="backImg('/huapu/column.png')">
        <vchart ref='vchartBar' themes="purple-passion" style='width: 100%;height: 100%;'></vchart>
      </div>

    </div>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import vchart from '@/components/module/chart/vchart.vue'
  import meterReadingStore from '@/page/system/meterReading/meterReadingStore.js'
  import request from "@/api/http.js";
  export default {
    components: {
      vchart,
    },

    data () {
      return {
        options: [{
          value: '1',
          label: '水'
        },{
          value: '2',
          label: '电'
        }],
        value: '2',
        powerData: {
          day: 0, //今日用电量  
          lasMonth: 0, //上月 今天 用电量 
          lasDay: 0, //昨日用电量 
          month: 0, //本月用电量 
          lasMonth2: 0, //上月 整月用电
          lasYear: 0, //去年 整月用电量
        },
        filterList: [],
        powerDateList: {},
        indexShow: -1,
        barOption: {
          toolbox: {
            right: 25,
            show: true,
            iconStyle: {
              borderColor: "#94d6da"

            },
            feature: {
              magicType: {type: ['line','bar']},
              restore: {},
              saveAsImage: {}
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          xAxis: [{
            type: 'category',
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: false

            },
            data: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19',
              '20','21','22','23','24','25','26','27','28','29','30','31'
            ],
          }],
          yAxis: [{
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: false

            },
            type: 'value',
          }],
          legend: {
            top: '6px',
            textStyle: {
              color: '#fff'
            },
            show: true,
          },
          grid: {
            height: '70%',
            width: '90%',
            left: '2%',
            right: '1%',
            bottom: '5%',
            containLabel: true
          },
          backgroundColor: '',
          series: [
          ]
        },

        day1: undefined, //今日用电量
        day2: undefined, //昨日用电量
        day3: undefined, //昨日同期
        month1: undefined,
        month2: undefined,
        month3: undefined,
        transformerList: [],
      }
    },

    mounted () {
      this.init()
      this.powerDate()
    },
    computed: {
      tongqi () {// 上月 日 同期  
        var d={
          num: Math.abs(this.powerData.day-this.powerData.lasMonth).toFixed(2),
          flag: this.powerData.day-this.powerData.lasMonth<0
        }
        return d
      },
      tongqi2 () {// 昨日 同期
        var d={
          num: Math.abs(this.powerData.day-this.powerData.lasDay).toFixed(2),
          flag: this.powerData.day-this.powerData.lasDay<0
        }
        return d
      },
      tongqi3 () {// 上月 月 同期
        var d={
          num: Math.abs(this.powerData.month-this.powerData.lasMonth2).toFixed(2),
          flag: this.powerData.month-this.powerData.lasMonth2<0
        }
        return d
      },
      tongqi4 () {// 去年 月 同期
        var d={
          num: Math.abs(this.powerData.month-this.powerData.lasYear).toFixed(2),
          flag: this.powerData.month-this.powerData.lasYear<0
        }
        return d
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      nowReadDeviceTree () {
        //当前单位可查看虚拟设备树
        return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
      },
      powerRoom () {
        //获取配电房
        var list=treeToList(this.nowReadDeviceTree,'next',item => {
          return item.hasOwnProperty("next")
        })
        return list.filter(item => {
          return item.devicetype==2
        })
      },
      imgName () {
        return resourcesStore.getters.getResourcesByName
      },
      backImg () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      upDown () {
        return value => {
          if(value>0) {
            return this.imgName('/huapu/up.png')
          } else {
            return this.imgName('/huapu/down.png')
          }
        }
      },
      getFengpingDateStyle () {
        return index => {
          if(index==this.indexShow) {
            return {
              'color': 'white'
            }
          } else {
            return {
              'color': '#697A98'
            }
          }
        }
      },

      getUpImg () {
        return resourcesStore.getters.getResourcesByName('/huapu/down.png')
      },
      getDownImg () {
        return resourcesStore.getters.getResourcesByName('/huapu/up.png')
      },
    },
    watch: {
      powerRoom (nv,ov) {
        this.filterList=copy(this.powerRoom)
      },
      filterList (nv,ov) {
        this.transformerList=[]
        this.recursiveTfr(nv)
      },
      nowUnit (nv,ov) {
        this.powerDate()
      },
    },
    methods: {
      valueFn () {
        setTimeout(() => {
          if(this.value==1) { //判断水
            this.getPowerValue2(this.$store.unitStore.getters.getNowUnit.id)
          } else {
            this.getPowerValue(this.$store.unitStore.getters.getNowUnit.id)
          }
          this.reloadBarChart();
        },200);
      },
      //图表初始化
      init () {
        this.barOption.series=[{
          name: '电量',
          type: 'bar',
          data: [],
          itemStyle: {
            color: '#1491ff',
          }
        },{
          name: '电费',
          type: 'bar',
          data: [],
          itemStyle: {
            color: '#fbd549',
          }
        }]

        this.$refs.vchartBar.setData(this.barOption)
      },
      // 水量水费数据
      reloadBarChart2 () {
        var params={
          timeStamp: new Date().getTime(),
          unitId: this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/cost/findWaterCostFromMonth",method: "get",params}).then(res => {
          var a=[];
          var b=[];
          if(res.code==200) {
            for(const key in res.data) {
              a.push(res.data[key]['总电量'])
              b.push(res.data[key]['总电费'])
            }

            this.barOption.series=[{
              name: '水量',
              type: 'bar',
              data: a,
              itemStyle: {
                color: '#1491ff',
              }
            },{
              name: '水费',
              type: 'bar',
              data: b,
              itemStyle: {
                color: '#fbd549',
              }
            }]
            this.$refs.vchartBar.setData(this.barOption)
          }
        })
      },
      // 电量电费数据
      reloadBarChart () {
        if(this.value==1) {//判断水
          this.reloadBarChart2();
          return
        }
        var params={
          timeStamp: new Date().getTime(),
          unitId: this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/cost/findCostFromMonth",method: "get",params}).then(res => {
          var a=[];
          var b=[];
          if(res.code==200) {
            for(const key in res.data) {
              a.push(res.data[key]['总电量'])
              b.push(res.data[key]['总电费'])
            }

            this.barOption.series=[{
              name: '电量',
              type: 'bar',
              data: a,
              itemStyle: {
                color: '#1491ff',
              }
            },{
              name: '电费',
              type: 'bar',
              data: b,
              itemStyle: {
                color: '#fbd549',
              }
            }]

            this.$refs.vchartBar.setData(this.barOption)
          }
        })


      },
      // 获取水量
      getPowerValue2 (unitId) {
        if(isempty(unitId)) {
          return
        }
        console.log(unitId,'获取水量');
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()

        var params={
          bgTime: new Date(year,0,1).getTime(),
          endTime: nowTime,
          unitId: unitId,
        }
        //获取今年用水量
        // request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {

        //   if(res.code=200) {
        //     this.powerData.day=Number(res.data);
        //   }
        // })


        //获取今日水量 
        var params={
          bgTime: nowZero,
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.day=Number(res.data);
          }
        })

        //获取昨日水量
        var params={
          bgTime: nowZero-24*60*60*1000,
          endTime: nowZero-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.lasDay=Number(res.data);
          }
        })


        // 获取上个月同一天用水量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        var params={
          bgTime: lastMonthDate.getTime(),
          endTime: lastMonthDate.getTime()+24*60*60*1000-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.lasMonth=Number(res.data);
          }
        })

        // 获取本月用水量
        var params={
          bgTime: new Date(year,month,1).getTime(),
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.month=Number(res.data);
          }
        })

        //获取上月用水量 
        var params={
          bgTime: new Date(year,month-1,1).getTime(),
          endTime: new Date(year,month-1,31).getTime()-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.lasMonth2=Number(res.data);
          }
        })

        // 获取去年同月用水量
        var params={
          bgTime: new Date(year-1,month,1).getTime(),
          endTime: new Date(this.getLastDay(year-1,month+1)).getTime(),
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.powerData.lasYear=Number(res.data);
            setTimeout(() => {
              this.electricAnalyze=this.electricAnalyze1
            },200);
          }
        })

      },

      // 获取用电量
      getPowerValue (unitId) {
        if(isempty(unitId)) {
          return
        }
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()

        //获取今日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero,nowTime,res => {
          this.powerData.day=Number(res)
        })
        //获取昨日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero-24*60*60*1000,nowZero-1,res => {
          this.powerData.lasDay=Number(res)
        })
        // 获取上个月同一天用电量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        this.$api.powerApi.getUnitUsePowerByDate(unitId,lastMonthDate.getTime(),lastMonthDate.getTime()+24*60*60*
          1000-1,res => {
            this.powerData.lasMonth=Number(res)
          })
        // 获取本月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month,1).getTime(),nowTime,res => {
          this.powerData.month=Number(res)
        })
        //获取上月 整月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month-1,1).getTime(),new Date(year,month-1,31)
          .getTime()-
          1,res => {
            this.powerData.lasMonth2=Number(res)
          })

        // 获取去年同月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year-1,month,1).getTime(),new Date(this.getLastDay(
          year-1,month+1)).getTime(),res => {
            this.powerData.lasYear=Number(res)
          })
      },
      // 时间计算
      getLastDay (year,month) {
        var new_year=year; //取当前的年份          
        var new_month=month++; //取下一个月的第一天，方便计算（最后一天不固定）          
        if(month>12) {
          new_month-=12; //月份减          
          new_year++; //年份增          
        }
        var new_date=new Date(new_year,new_month,1); //取当年当月中的第一天          
        return year+'-'+new_month+'-'+(new Date(new_date.getTime()-1000*60*60*24)).getDate(); //获取当月最后一天日期          
      },




      powerDate () {
        if(!isempty(this.nowUnit.id)) {

          // 电量电费
          if(this.value==1) {
            this.getPowerValue2(this.$store.unitStore.getters.getNowUnit.id)
          } else {
            // 获取用电量
            this.getPowerValue(this.$store.unitStore.getters.getNowUnit.id)
          }
          this.reloadBarChart()

        }
      },

      recursiveTfr (item) {
        item.forEach(i => {
          if(!isempty(i.archivesTypeCode)||i.archivesTypeCode=='Transformer') {
            this.transformerList.push(i)
          } else {
            if(!isempty(i.next)) {
              this.recursiveTfr(i.next)
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .hpElectricityBody {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    margin: 10px;
    position: relative;
  }

  .hpElectricityBody span,
  .hpElectricityBody p {
    font-size: 12px;
  }

  .hpElectricityTop {
    height: 20%;
    width: 100%;
  }

  .hpElectricityTop .searchBar {
    width: 40%;
    margin-right: 20px;
  }

  .searchBar input {
    width: 100%;
    background-color: rgba(0, 0, 0, 0);
    color: white;
    border: 0;
    outline: none;
    border-bottom: .01rem solid yellow;
    border-radius: 0;
  }

  .searchBar input:focus {
    border: 0;
    outline: none;
    background-color: #143a70;
    border-bottom: .01rem solid yellow;
    border-radius: 0;
  }

  .hpElectricityTop .searchBar img {
    height: 22px;
  }

  .yearEnergyUsed {
    color: white;
    font-size: .18rem !important;
  }

  .hpElectricityBody .dropDownList {
    width: 37%;
    background-color: white;
    position: absolute;
    left: 11%;
    max-height: 40%;
    z-index: 999;
    top: 15%;
    overflow: overlay;
  }

  .hpElectricityBody .dropDownList ul li {
    padding: 0 0 .1rem .1rem;
  }

  .hpElectricityBody .dropDownList ul li:nth-child(1) {
    padding-top: .1rem;
  }

  .hpElectricityBody .dropDownList ul li:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .electricityDetailed {
    width: 100%;
    padding: 5px 0;
    height: calc(50% - 10px);
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .todayElectricity {
    width: 13%;
    height: 100%;
    padding-left: .1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .todayElectricity span {
    color: white;
  }

  .todayBack {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dayYearOnYear {
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 100%;
    justify-content: space-between
  }

  .dayYearOnYear img {
    width: .05rem;
  }

  .tb1 {
    height: calc(50% - 10px);
    padding: 4px 10px;
  }

  .tb1 span {
    color: white;
  }

  .electricityGraphics {
    width: 100%;
    height: 49%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .energyConsumption {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .pingguPeak {
    width: 40%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }

  .pingguPeak .fengpingDate {
    width: 10%;
    height: 100%;
  }

  .pingguPeak .fengpingDate p {
    color: #697A98;
  }

  .pingguPeak .fengpingDate p:nth-child(1) {
    padding-top: .1rem;
  }

  .roundDiv {
    width: 100%;
    height: calc(100% - 20px);
    position: relative;
  }

  @keyframes rotation {

    from {
      -webkit-transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(360deg);
    }

  }


  .roundDiv img {
    height: 100%;
    /* animation: rotation 10s linear infinite; */
  }

  .roundDiv img,
  .roundDiv span {
    position: absolute;
  }

  .tbtext {
    color: #57ba46 !important;
    line-height: 14px;
  }

  .areaTitle {
    color: #fff;
    position: absolute;
    margin-left: 62px;
    z-index: 9;
  }
</style>